import React from 'react'
import { Link } from 'react-router-dom'
import '../searchService/SearchService.css'


const SearchWorker = () => {
  return (
           
    <div className='card-serch-sec'>
        <div className='card-search-com d-flex flex-wrap justify-content-center gap-4 mb-3'>
            <Link to='/worker' rel='stylesheet' className='card-box d-flex flex-wrap'>
                <div className='card-img'>
                    <div className='card-img-top'>

                    </div>
                    <div className='card-text'>
                        <p>Description...</p>
                    </div>
                </div>
                <div className='card-details d-flex flex-md-nowrap flex-wrap'>
                    <div className='left-details'>
                        <h2>Blowjob</h2>
                        <h3>Sugar baby, stripper</h3>
                        <div className='rating-box d-flex align-items-center'>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.69884 0.453077L11.9056 5.09873C11.9558 5.21665 12.0347 5.31878 12.1346 5.39497C12.2344 5.47113 12.3517 5.5187 12.4746 5.5329L17.3461 6.28547C17.4872 6.30437 17.6202 6.36473 17.7295 6.45951C17.8389 6.55428 17.9202 6.67955 17.9638 6.82067C18.0075 6.96181 18.0117 7.11299 17.976 7.25654C17.9405 7.40011 17.8664 7.53011 17.7624 7.63141L14.2511 11.264C14.1615 11.3513 14.0942 11.4606 14.0555 11.5819C14.0167 11.7032 14.0076 11.8328 14.029 11.9587L14.8756 17.0674C14.9002 17.2143 14.8846 17.3652 14.8309 17.5033C14.7772 17.6414 14.6874 17.7609 14.5717 17.8485C14.4561 17.9359 14.3191 17.9877 14.1765 17.9981C14.034 18.0084 13.8915 17.9768 13.7653 17.9068L9.37962 15.4899C9.26733 15.4324 9.14388 15.4026 9.01877 15.4026C8.89367 15.4026 8.77023 15.4324 8.65792 15.4899L4.2722 17.9068C4.14602 17.9768 4.00356 18.0084 3.86101 17.9981C3.71846 17.9877 3.58154 17.9359 3.46586 17.8485C3.35017 17.7609 3.26034 17.6414 3.2066 17.5033C3.15288 17.3652 3.13737 17.2143 3.16188 17.0674L4.0085 11.9008C4.02995 11.7749 4.02088 11.6454 3.9821 11.524C3.94332 11.4027 3.87605 11.2934 3.78643 11.2061L0.233446 7.63141C0.128331 7.52735 0.054408 7.39372 0.0206324 7.24676C-0.0131433 7.09977 -0.00532113 6.94573 0.0431481 6.80329C0.0916187 6.66085 0.178657 6.53613 0.293723 6.44422C0.408789 6.35232 0.546942 6.29716 0.691444 6.28547L5.56293 5.5329C5.6859 5.5187 5.80315 5.47113 5.90299 5.39497C6.00284 5.31878 6.08178 5.21665 6.13197 5.09873L8.33871 0.453077C8.3988 0.317774 8.49476 0.203221 8.61527 0.122939C8.73577 0.0426575 8.87578 0 9.01877 0C9.16177 0 9.30179 0.0426575 9.42229 0.122939C9.54278 0.203221 9.63874 0.317774 9.69884 0.453077Z" fill="#FD59D9"/></svg>
                            4.5 <span>(182)</span>
                        </div>
                        <p>Melbourne, Victoria</p>
                        <p>Age: 20-30</p>
                    </div>
                    <div className='right-details'>
                        <ul>
                            <li>
                                <Link rel='stylesheet' to='/' className='btn btn-border'>Follow</Link>
                            </li>
                            <li>
                                <Link rel='stylesheet' to='/worker' className='btn btn-border'>Book</Link>
                            </li>
                            <li>
                                <span className='color-text-pink'>From $100</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </Link>
        </div>
        <div className='card-search-com d-flex flex-wrap justify-content-center gap-4 mb-3'>
            <Link to='/worker' rel='stylesheet' className='card-box d-flex flex-wrap'>
                <div className='card-img'>
                    <div className='card-img-top'>

                    </div>
                    <div className='card-text'>
                        <p>Description...</p>
                    </div>
                </div>
                <div className='card-details d-flex flex-md-nowrap flex-wrap'>
                    <div className='left-details'>
                        <h2>Blowjob</h2>
                        <h3>Sugar baby, stripper</h3>
                        <div className='rating-box d-flex align-items-center'>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.69884 0.453077L11.9056 5.09873C11.9558 5.21665 12.0347 5.31878 12.1346 5.39497C12.2344 5.47113 12.3517 5.5187 12.4746 5.5329L17.3461 6.28547C17.4872 6.30437 17.6202 6.36473 17.7295 6.45951C17.8389 6.55428 17.9202 6.67955 17.9638 6.82067C18.0075 6.96181 18.0117 7.11299 17.976 7.25654C17.9405 7.40011 17.8664 7.53011 17.7624 7.63141L14.2511 11.264C14.1615 11.3513 14.0942 11.4606 14.0555 11.5819C14.0167 11.7032 14.0076 11.8328 14.029 11.9587L14.8756 17.0674C14.9002 17.2143 14.8846 17.3652 14.8309 17.5033C14.7772 17.6414 14.6874 17.7609 14.5717 17.8485C14.4561 17.9359 14.3191 17.9877 14.1765 17.9981C14.034 18.0084 13.8915 17.9768 13.7653 17.9068L9.37962 15.4899C9.26733 15.4324 9.14388 15.4026 9.01877 15.4026C8.89367 15.4026 8.77023 15.4324 8.65792 15.4899L4.2722 17.9068C4.14602 17.9768 4.00356 18.0084 3.86101 17.9981C3.71846 17.9877 3.58154 17.9359 3.46586 17.8485C3.35017 17.7609 3.26034 17.6414 3.2066 17.5033C3.15288 17.3652 3.13737 17.2143 3.16188 17.0674L4.0085 11.9008C4.02995 11.7749 4.02088 11.6454 3.9821 11.524C3.94332 11.4027 3.87605 11.2934 3.78643 11.2061L0.233446 7.63141C0.128331 7.52735 0.054408 7.39372 0.0206324 7.24676C-0.0131433 7.09977 -0.00532113 6.94573 0.0431481 6.80329C0.0916187 6.66085 0.178657 6.53613 0.293723 6.44422C0.408789 6.35232 0.546942 6.29716 0.691444 6.28547L5.56293 5.5329C5.6859 5.5187 5.80315 5.47113 5.90299 5.39497C6.00284 5.31878 6.08178 5.21665 6.13197 5.09873L8.33871 0.453077C8.3988 0.317774 8.49476 0.203221 8.61527 0.122939C8.73577 0.0426575 8.87578 0 9.01877 0C9.16177 0 9.30179 0.0426575 9.42229 0.122939C9.54278 0.203221 9.63874 0.317774 9.69884 0.453077Z" fill="#FD59D9"/></svg>
                            4.5 <span>(182)</span>
                        </div>
                        <p>Melbourne, Victoria</p>
                        <p>Age: 20-30</p>
                    </div>
                    <div className='right-details'>
                        <ul>
                            <li>
                                <Link rel='stylesheet' to='/' className='btn btn-border'>Follow</Link>
                            </li>
                            <li>
                                <Link rel='stylesheet' to='/worker' className='btn btn-border'>Book</Link>
                            </li>
                            <li>
                                <span className='color-text-pink'>From $100</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </Link>
        </div>
    </div>
  )
}

export default SearchWorker
